import { render } from "./App.vue?vue&type=template&id=1bb797ec"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1bb797ec&lang=css"
script.render = render

export default script